export default {
  width: 19,
  height: 19,
  fill: false,
  svg: `
  <path d="M8.3675 9.841L1 6.894L17.2085 1L11.3145 17.2085L8.3675 9.841ZM8.3675 9.841L11.3145 6.894" stroke="#4E888C" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
  `
}
